import { VERSION_STATUS_META, type VersionStatus } from '../data/types';

/** 상대 시간 표기. "3일 전" 처럼 실무자가 바로 읽을 수 있게. */
export function relTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return '방금';
  if (min < 60) return `${min}분 전`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}시간 전`;
  const day = Math.floor(hr / 24);
  if (day < 31) return `${day}일 전`;
  return new Date(iso).toLocaleDateString('ko-KR');
}

/**
 * 버전 상태 표시.
 * 접근성 요구: 색상만으로 구분하지 않도록 아이콘 + 텍스트를 항상 함께 낸다.
 */
export function VersionStatusBadge({ status }: { status: VersionStatus }) {
  const m = VERSION_STATUS_META[status];
  return (
    <span className="vstatus" style={{ color: m.color }}>
      <span className="vstatus__icon" aria-hidden="true">
        {m.icon}
      </span>
      {m.label}
    </span>
  );
}

export function FavoriteStar({
  on,
  onToggle,
  label,
}: {
  on: boolean;
  onToggle: () => void;
  label: string;
}) {
  return (
    <button
      type="button"
      className="star"
      aria-pressed={on}
      aria-label={`${label} 즐겨찾기 ${on ? '해제' : '추가'}`}
      title={on ? '즐겨찾기 해제' : '즐겨찾기 추가'}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      {on ? '★' : '☆'}
    </button>
  );
}
